<template>
  <div class="joinEnterprise">
    <div class="header">
      <enterprise-header :key="keyadd"></enterprise-header>
    </div>
    <div class="content">
      <div class="main">
        <div style="width:1280px;height:828px;background:#ffffffcf;margin:17px auto;margin-bottom:0;border-radius: 4px">
          <img v-if="joinStatus == 0" :src="gerenxinxi" alt="" style="margin-top:114px" />
          <p v-if="joinStatus == 0" style="font-size:22px;">
            欢迎来到{{ $appTitle }}，您被邀请加入企业【{{ enterpriseName }}】
          </p>
          <div v-if="joinStatus == 0" style="margin-top:29px">
            <el-button type="primary" size="small" @click="tongyi">
              同意
            </el-button>
            <el-button type="danger" size="small" plain @click="jujue">
              拒绝
            </el-button>
          </div>
          <img v-if="joinStatus == 1" :src="gerenxinxi" alt="" style="margin-top:114px" />
          <p v-if="joinStatus == 1" style="font-size:22px;">
            您已加入企业【{{ enterpriseName }}】
          </p>
          <div v-if="joinStatus == 1" style="margin-top:29px">
            <el-button type="primary" size="small" @click="jinru">
              点击进入企业
            </el-button>
          </div>
          <img v-if="joinStatus == 2" :src="gerenxinxi" alt="" style="margin-top:114px" />
          <p v-if="joinStatus == 2" style="font-size:22px;">
            您已拒绝企业【{{ enterpriseName }}】的加入邀请
          </p>
          <img v-if="joinStatus == -1" :src="lianjieshixioa" alt="" style="margin-top:114px" />
          <p v-if="joinStatus == -1" style="font-size:22px;">
            很抱歉,此邀请链接信息中未匹配到当前账户信息
          </p>
          <div v-if="joinStatus == -1" style="margin-top:29px">
            <el-button type="primary" size="small" @click="logOut">
              退出登录
            </el-button>
          </div>
          <img v-if="joinStatus == 11" :src="gerenxinxi" alt="" style="margin-top:114px" />
          <p v-if="joinStatus == 11" style="font-size:22px;">
            您已加入项目【{{ projectName }}】
          </p>
          <div v-if="joinStatus == 11" style="margin-top:29px">
            <el-button type="primary" size="small" @click="getIntoProgect">
              点击进入项目
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog v-dialogDrag title="提示" :visible.sync="dialogVisible" width="432px" :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false">
      <span style="font-size:14px;color:000;margin-top:12px">
        您的姓名
      </span>
      <div style="margin-top:12px">
        <el-input v-model="inputname" placeholder="请输入姓名" maxlength="10" show-word-limit size="small"></el-input>
      </div>
      <div style="margin-top:46px">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" style="width:392px" @click="quedingjoin">
          确定加入企业
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import registerService from "@/CommonDP/service/register-service";
import EnterpriseHeader from "./components/userEnterHeader";
import request from "@/CommonDP/service/login-service";
import createProjectService from "@/CommonDP/service/project-service";
import { getToken, storage } from "@/CommonDP/utils";
import { mapState } from "vuex";
import enterpriseService from "@/CommonDP/service/enterprise-service";

export default {
  name: "Enterprise",
  components: {
    EnterpriseHeader
  },
  data() {
    return {
      gerenxinxi: require("@/CommonDP/assets/enterprise/gerenxinxi.png"),
      lianjieshixioa: require("@/CommonDP/assets/enterprise/lianjieshixioa.png"),
      enterpriseName: "",
      dialogVisible: false,
      inputname: "",
      joinStatus: -1,
      enterpriseId: "",
      keyadd: 1,
      nameshow: false,
      isTrial: "",
      projectName: "",
      projectId: ""
    };
  },

  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo
    })
  },
  created() {
    if (!getToken()) {
      var code = this.$route.query.code;
      this.$router.replace({ path: "/login", query: { code: code }});
    } else {
      this.querydetails();
    }
  },
  methods: {
    querydetails() {
      this.loadingling = true;
      registerService
        .inviteverifyInviteCode(this.$route.query.code)
        .then((res) => {
          // 0未加入 1同意 2拒绝 需要判断不同的情况下页面展示情况
          // joinPrjStatus=null 只邀请加入企业，未邀请加入项目
          // joinPrjStatus=0 邀请加入项目，但还未加入项目
          // joinPrjStatus=1 邀请加入项目，且已加入项目
          if (res.data.joinStatus === 1) {
            // 已经加入了企业
            this.projectName = res.data.prjName;
            this.projectId = res.data.prjId;
            if (res.data.joinPrjStatus === 0) {
              this.joinStatus = 11;
              this.queryProjectJoin();
            } else if (res.data.joinPrjStatus === 1) {
              this.joinStatus = 11;
            } else {
              this.joinStatus = 1;
            }
          } else {
            this.joinStatus = res.data.joinStatus;
          }
          this.enterpriseName = res.data.enterpriseName;
          this.enterpriseId = res.data.enterpriseId;
          this.isTrial = res.data.isTrial;
          if (res.data.name) {
            this.nameshow = true;
          } else {
            this.nameshow = false;
          }
        })
        .catch(() => {});
    },
    async queryProjectJoin() {
      await registerService.projectJoin(this.$route.query.code);
    },
    tongyi() {
      this.inputname = "";
      if (this.nameshow) {
        this.quedingjoin2();
      } else {
        this.dialogVisible = true;
      }
    },
    jujue() {
      this.$confirm("您将拒绝企业【" + this.enterpriseName + "】的加入邀请是否确认?", "拒绝", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const data = {
            inviteCode: this.$route.query.code
          };
          registerService
            .joinrefuse(data)
            .then((res) => {
              if (res.result === "0") {
                this.querydetails();
                this.$message({
                  duration: 1000,
                  message: "拒绝成功",
                  type: "success",
                  showClose: true
                });
              }
            })
            .catch(() => {
              this.querydetails();
            });
        })
        .catch(() => {});
    },
    quedingjoin() {
      if (this.inputname) {
        var data = {
          inviteCode: this.$route.query.code,
          name: this.inputname
        };
        registerService
          .joinagree(data)
          .then((res) => {
            if (res.result === "0") {
              this.dialogVisible = false;
              this.querydetails();
              this.setstorname();
              this.$message({
                duration: 1000,
                message: "同意成功",
                type: "success",
                showClose: true
              });
            }
          })
          .catch(() => {});
      } else {
        this.$message({
          duration: 1000,
          message: "请输入姓名",
          type: "warning",
          showClose: true
        });
      }
    },
    quedingjoin2() {
      this.$confirm("您将同意企业【" + this.enterpriseName + "】的加入邀请是否确认?", "同意", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const data = {
            inviteCode: this.$route.query.code,
            name: this.inputname
          };
          registerService
            .joinagree(data)
            .then((res) => {
              if (res.result === "0") {
                this.dialogVisible = false;
                this.querydetails();
                this.$message({
                  duration: 1000,
                  message: "同意成功",
                  type: "success",
                  showClose: true
                });
              }
            })
            .catch(() => {
              this.querydetails();
            });
        })
        .catch(() => {});
    },
    setstorname() {
      var data = this.userInfo;
      data.name = this.inputname;
      data.token = getToken();
      this.$store.dispatch("setUserInfo", data);
      this.keyadd += 1;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    async jinru() {
      const res = await enterpriseService.userselectEnterprise(this.enterpriseId);
      if (res.result === "0") {
        this.$store.dispatch("setIsTrial", this.isTrial);
        this.$store.dispatch("setUnauthorized", 1);
        this.$store.dispatch("setEnterpriseId", this.enterpriseId);
        await this.$store.dispatch("setRouterNav", []);
        await this.$store.commit("saveFlatRoutes", []);
        // await this.$store.dispatch("queryEnterpriseDept");
        await this.$store.dispatch("GetModuleList", this.enterpriseId);
        var data = {
          createTime: "",
          enterPrjTime: "",
          prjCode: "",
          prjId: "",
          prjName: ""
        };
        this.$store.dispatch("updatePrj", data);
        await this.$router.push({ name: "mainMg" });
      }
    },
    logOut() {
      request
        .logout()
        .then(() => {
          var code = this.$route.query.code;
          this.$router.replace({ path: "/login", query: { code: code }});
        })
        .catch(() => {});
    },
    async getIntoProgect() {
      const res = await createProjectService.viewList(this.projectId);
      const prjData = {
        createTime: res.data.createDate,
        enterPrjTime: "",
        prjCode: res.data.prjCode,
        prjId: res.data.prjId,
        prjName: res.data.prjName
      };
      this.$store.dispatch("setUnauthorized", 1);
      this.$store.dispatch("setEnterpriseId", this.enterpriseId);
      this.$store.dispatch("setIsTrial", this.isTrial);
      await this.$store.dispatch("updatePrj", prjData);
      await this.$store.dispatch("getModuleProjectList");
      await this.$router.push({ name: "project" });
    }
  }
};
</script>

<style lang="scss" scoped>
.joinEnterprise {
  min-width: 1270px;
  width: 100%;
  min-height: 937px;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  .header {
    width: 100%;
    height: 68px;
    line-height: 68px;
    overflow: hidden;
    position: absolute;
    top: 0;
    text-align: center;
    box-sizing: border-box;
  }
  .content {
    position: absolute !important;
    position: relative;
    top: 68px !important;
    bottom: 0px;
    width: 100%;
    overflow: hidden;
    height: auto !important;
    left: 0px;
  }
  .main {
    height: 100%;
    min-height: 1000px;
    overflow-y: auto;
    text-align: center;
    background: url("../../assets/enterprise/qiye.png") no-repeat;
    background-size: 100% 100%;
    background-position: center center;
  }
}
</style>
